<mat-card class="cardWithShadow">
  <mat-card-content style="padding: 36px 36px 0px 36px">
    <mat-card-title>
      <h2>Ver Lista de SKUs</h2>
    </mat-card-title>

    <div *ngIf="!isLoading" class="row justify-content-between">
      <div class="w-100 col-sm-4" style="display: flex; gap: 12px">
        <button
          mat-button
          mat-flat-button
          mat-raised-button
          color="primary"
          (click)="openDialog(null)"
        >
          Crear SKU
        </button>
        <!-- <button
          mat-button
          mat-flat-button
          mat-raised-button
          color="accent"
          (click)="fileInput.click()"
        >
          <i-tabler
            name="file-spreadsheet"
            class="icon-20"
            style="margin-right: 8px"
          ></i-tabler>
          Importar Excel
        </button>
        <input
          #fileInput
          type="file"
          accept=".xlsx, .xls, .csv"
          style="display: none"
          (change)="onFileSelected($event)"
        /> -->
      </div>
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <input
            matInput
            placeholder="Buscar..."
            (keyup)="applyFilter($event)"
          />
          <mat-icon matSuffix>
            <i-tabler name="search" class="icon-20"></i-tabler>
          </mat-icon>
        </mat-form-field>
      </div>
      <div class="col-lg-3">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-label>CATEGORÍA</mat-label>
          <mat-select
            [(value)]="selectedCategories"
            (selectionChange)="applyFilterSelect()"
          >
            <mat-option value="{{ null }}">No seleccionar</mat-option>
            <mat-option
              *ngFor="let categoria of arrayCategorias"
              value="{{ categoria }}"
              >{{ categoria }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>

  <mat-card-content
    *ngIf="isLoading"
    class="d-flex flex-col flex-wrap align-items-center justify-content-center"
    style="padding-bottom: 36px"
  >
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    <p>Cargando insumos del Almacén (SKUs)...</p>
  </mat-card-content>

  <mat-card-content
    [style.display]="
      !isLoading && dataSource.filteredData.length !== 0 ? 'block' : 'none'
    "
    style="padding: 36px"
  >
    <div class="table-responsive">
      <table
        mat-table
        matSort
        [dataSource]="dataSource"
        class="no-wrap m-t-0 v-middle w-100"
      >
        <ng-container matColumnDef="id">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Código
          </th>
          <td
            mat-cell
            *matCellDef="let foodItemSku"
            class="f-s-14 custom-column"
          >
            {{ foodItemSku?.codigoInsumo || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="nombreInsumo">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Nombre
          </th>
          <td
            mat-cell
            *matCellDef="let foodItemSku"
            class="f-s-14 custom-column"
          >
            {{ foodItemSku?.nombreInsumo || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="categoria">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Categoría
          </th>
          <td
            mat-cell
            *matCellDef="let foodItemSku"
            class="f-s-14 custom-column"
          >
            {{ foodItemSku?.categoria || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="peso">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Peso
          </th>
          <td
            mat-cell
            *matCellDef="let foodItemSku"
            class="f-s-14 custom-column"
          >
            {{ (foodItemSku?.peso | number: '1.0-2') || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="unidadMedida">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Unidad de Medida
          </th>
          <td
            mat-cell
            *matCellDef="let foodItemSku"
            class="f-s-14 custom-column"
          >
            {{ foodItemSku?.unidadMedida || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="historialCostos">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Costo
          </th>
          <td
            mat-cell
            *matCellDef="let foodItemSku"
            class="f-s-14 custom-column"
          >
            {{
              (foodItemSku?.historialCostos?.length
                ? foodItemSku.historialCostos[
                    foodItemSku.historialCostos.length - 1
                  ]?.costo
                : 0
              ) | number: '1.2-2'
            }}
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="stock">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Stock
          </th>
          <td
            mat-cell
            *matCellDef="let foodItemSku"
            class="f-s-14 custom-column"
          >
            {{ (foodItemSku?.stock | number: '1.0-0') || '-' }}
          </td>
        </ng-container> -->

        <ng-container matColumnDef="stock">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Stock Real
          </th>
          <td
            mat-cell
            *matCellDef="let foodItemSku; let i = index"
            class="f-s-14 custom-column"
          >
            <div
              style="
                display: flex;
                gap: 10px;
                align-items: center;
                justify-content: center;
              "
            >
              <div *ngIf="activeTextArea !== i" style="max-width: 80%">
                {{ (foodItemSku?.stock | number: '1.2-2') || '-' }}
              </div>
              <a
                *ngIf="activeTextArea !== i"
                (click)="
                  setActiveInput(i, foodItemSku); $event.stopPropagation()
                "
                class="icon-Active"
                style="cursor: pointer"
              >
                <i-tabler name="pencil" class="icon-20"></i-tabler>
              </a>

              <mat-form-field
                appearance="outline"
                class="w-100 hide-hint"
                *ngIf="activeTextArea === i"
                style="max-width: 120px"
              >
                <input
                  (click)="$event.stopPropagation()"
                  [(ngModel)]="newStockRealInputValue"
                  matInput
                  min="0"
                  step="1"
                  type="number"
                />
              </mat-form-field>

              <a
                *ngIf="activeTextArea === i"
                (click)="updateStockReal(foodItemSku); $event.stopPropagation()"
                class="icon-Active"
                style="cursor: pointer"
              >
                <i-tabler name="check" class="icon-20"></i-tabler>
              </a>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="stockTeorico">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Stock Teórico
          </th>
          <td
            mat-cell
            *matCellDef="let foodItemSku"
            class="f-s-14 custom-column"
          >
            {{ (foodItemSku?.stockTeorico | number: '1.2-2') || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="stockAjuste">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Stock Ajuste
          </th>
          <td
            mat-cell
            *matCellDef="let foodItemSku"
            class="f-s-14 custom-column"
          >
            {{
              (foodItemSku?.stock - foodItemSku?.stockTeorico
                | number: '1.2-2') || '-'
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="estado">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Estado
          </th>
          <td
            mat-cell
            *matCellDef="let foodItemSku"
            class="f-s-14 custom-column"
          >
            {{ foodItemSku?.estado || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="modificar">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="f-w-600 f-s-15 custom-column"
          >
            Editar
          </th>
          <td
            mat-cell
            *matCellDef="let foodItemSku; let i = index"
            class="f-s-14 custom-column"
          >
            <button
              mat-icon-button
              color="primary"
              (click)="openDialog(foodItemSku)"
            >
              <i-tabler name="pencil"></i-tabler>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="eliminar">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="f-w-600 f-s-15 custom-column"
          >
            Eliminar
          </th>
          <td
            mat-cell
            *matCellDef="let foodItemSku; let i = index"
            class="f-s-14 custom-column"
          >
            <button
              mat-icon-button
              color="primary"
              (click)="deleteSKU(foodItemSku)"
            >
              <i-tabler name="trash"></i-tabler>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <div [hidden]="isLoading">
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>

  <div
    *ngIf="!isLoading && dataSource?.filteredData?.length === 0"
    class="d-flex justify-content-center align-items-center"
    style="width: 100%; height: 400px; text-align: center"
  >
    Lo sentimos. No tenemos datos para esta búsqueda.
    <br />Por favor, intenta con otro término.
  </div>
</mat-card>
